<template>
  <div>
    <ItemCardListPrimary
      v-on="$listeners"
      :itemLength="tenantTeams.length"
    >
      <TenantTeamCardAction />
      <TenantTeamCard
        v-for="(tenantTeam, index) in tenantTeams"
        :key="index"
        :tenantTeam="tenantTeam"
        :tenantUser="tenantUser"
      />
    </ItemCardListPrimary>
  </div>
</template>

<script>
  import ItemCardListPrimary from '@modules/card/item-card-list-primary'
  import TenantTeamCard from '@teamup/modules/tenant-team-card'
  import TenantTeamCardAction from '@teamup/modules/tenant-team-card-action'

  export default {
    name: 'TenantTeamCardList',
    components: {
      ItemCardListPrimary,
      TenantTeamCard,
      TenantTeamCardAction,
    },
    props: {
      isLoading: {
        type: Boolean,
        reuqired: false,
        default: false,
      },
      tenantTeams: {
        type: Array,
        required: false,
        default: () => [],
      },
      tenantUser: {
        type: Object,
        required: false,
        default: () => { return {}; },
      },
    },
  };
</script>
